import styled from '@emotion/styled';
import useActiveNavLink from '@shared/hooks/useActiveNavLink';
import { ISubMenuItem } from '@shared/models/components/IMenuProps';
import { NavLink } from 'react-router';
import { TextSize90 } from '../text/Typography';
import { MenuActiveBar, MenuTruncate, MixinMenuBaseLink, MixinMenuFlexContainer } from './CommonMenuStyles';

interface ISubMenuItemProps {
    subItem: ISubMenuItem;
}

export default function SubMenuItem({ subItem }: ISubMenuItemProps) {
    const { startMatch, exactMatch } = useActiveNavLink(subItem.href);
    const isActive =
        !subItem.activeStateMatchCriteria || subItem.activeStateMatchCriteria == 'start' ? startMatch : exactMatch;
    const matchUrlExactly = subItem.activeStateMatchCriteria == 'exact' || subItem.activeStateMatchCriteria == 'end';
    return (
        <SubmenuItem>
            <SubMenuActiveBar isActive={isActive} isSubActive={false} />
            <SubmenuLink to={subItem.href} role="menuitem" end={matchUrlExactly} viewTransition>
                <MenuTruncate>{subItem.label}</MenuTruncate>
            </SubmenuLink>
        </SubmenuItem>
    );
}

const SubmenuItem = styled.span`
    ${MixinMenuFlexContainer}
    padding: 0 0 0 0px;
    &:hover,
    &:focus {
        background-color: ${(props) => props.theme.banner.accent.background};
        outline: none;
    }
`;

const SubmenuLink = styled(NavLink)`
    ${MixinMenuBaseLink}
    padding: 1rem 0.5rem 1rem 40px;
    ${TextSize90}
    color: ${(props) => props.theme.color.text};
    &.active {
        color: ${(props) => props.theme.color.accent};
    }
`;
const SubMenuActiveBar = styled(MenuActiveBar)``;
